import { ProviderModel } from "types/generated/models";
import { useClientPortalSelector, selectBooking, useClientPortalDispatch, setAvailableProviders } from "../../../redux";
import { useGetQuery } from "hooks/useClientPortalQuery";
import { useEffect } from "react";
import { BookingType } from "types/appointmentBooking";
import { useAppointmentBookingApi } from "../../../hooks/useAppointmentBookingApi";

export interface IProvidersHook {
    providers?: ProviderModel[] | null;
    isLoading: boolean;
}

const buildQueryParams = (locationId: number, bookingType: BookingType, serviceId?: number): string => {
    const params = new URLSearchParams({
        locationId: locationId.toString(),
        type: bookingType,
    });

    if (bookingType === BookingType.CLIENT && serviceId) {
        params.set("serviceId", serviceId.toString());
    }

    return params.toString();
};

export function useProviders(): IProvidersHook {
    const { location, service, session } = useClientPortalSelector(selectBooking);
    const { getEndpoint } = useAppointmentBookingApi();
    const dispatch = useClientPortalDispatch();

    const locationId = location.data?.locationId;
    const serviceId = service.data?.serviceId;
    const bookingType = session.bookingType;

    const shouldFetch = bookingType === BookingType.CLASS ? !!locationId : !!locationId && !!serviceId;

    const queryUrl =
        shouldFetch && locationId
            ? `${getEndpoint("GetProviders")}?${buildQueryParams(locationId, bookingType, serviceId)}`
            : "";

    const { data, isLoading } = useGetQuery<ProviderModel[]>({
        url: queryUrl,
        options: {
            enabled: shouldFetch,
        },
    });

    useEffect(() => {
        if (data?.length && !isLoading) {
            dispatch(setAvailableProviders(data));
        }
    }, [data, isLoading, dispatch]);

    return {
        providers: data,
        isLoading,
    };
}
